import marshmello from '../assets/marshmello-1.png';
import marshmello2 from '../assets/marshmello-album.png';
import bts from '../assets/bts-album.png';
import beyonce from '../assets/beyonce-album.png';
import tupac from '../assets/2pac-album.png';
import skillet from '../assets/rock-n-roll.jpg';
import four from '../assets/four.png';
import blue from '../assets/blue-album.png';
import some from '../assets/some-album.png';
import metal from '../assets/metal-album.jpg';
import singer from '../assets/singer.png';
import woman from '../assets/woman.png';

import mashmelloAttire from '../assets/hoodie.png';
import daftpunkHelmet1 from '../assets/daft-punk-1.png';
import daftpunkHelmet2 from '../assets/daft-punk-2.png';
import guitar from '../assets/country.png';
import dafthoodie from '../assets/hoodie-2.png';
import live from '../assets/live-music.png';
import stone from '../assets/nirvana-album.png';

export const ListOfAlbums = [
	{
		name: "Mashmello's Vision",
		image: marshmello,
		price: '219',
		ratings: '4.7',
		artist: 'Mashmello',
		views: '98.2 M+',
	},
	{
		name: 'Legendary',
		image: skillet,
		price: '519.29',
		ratings: '4.9',
		artist: 'Skillet',
		views: '1.92 B+',
	},
	{
		name: 'African Queen',
		image: tupac,
		price: '500',
		ratings: '4.1',
		artist: '2Pac Shakoor',
		views: '91 M+',
	},
	{
		name: 'BTS SpotLight',
		image: bts,
		price: '59.89',
		ratings: '3.7',
		artist: 'B T S',
		views: '9 M+',
	},
	{
		name: 'Am Alive',
		image: beyonce,
		price: '99.19',
		ratings: '3.9',
		artist: 'Beyonce',
		views: '51.8 M+',
	},
	{
		name: 'GasLight',
		image: four,
		price: '19.49',
		ratings: '2.0',
		artist: 'The Four',
		views: '982 K+',
	},
	{
		name: 'You Make Me Wanna',
		image: blue,
		price: '100.23',
		ratings: '2.0',
		artist: 'Blue',
		views: '4 M+',
	},
	{
		name: 'God IS a Woman',
		image: woman,
		price: '519.29',
		ratings: '4.9',
		artist: 'Britney Spears',
		views: '1.8 M+',
	},
	{
		name: 'Door Bell',
		image: some,
		price: '5.13',
		ratings: '3.1',
		artist: 'The Strangers',
		views: '10',
	},
	{
		name: 'Crazy Metal',
		image: metal,
		price: '89.81',
		ratings: '4.8',
		artist: 'Metalica',
		views: '112 K+',
	},
	{
		name: 'Disco Jocery',
		image: marshmello2,
		price: '1001.90',
		ratings: '5',
		artist: 'Mashmello',
		views: '20 M+',
	},
	{
		name: 'Wedding Ringer',
		image: singer,
		price: '815.1',
		ratings: '3.9',
		artist: 'Casting Crows',
		views: '19 M+',
	},
];

export const ListOfAttires = [
	{
		name: "Mashmello's Hoodie",
		image: mashmelloAttire,
		description:
			'This is the Hoddie Jacket tht was once wore by mashmello, It was then bought from him and here is it being Axioned!',
	},
	{
		name: "DaftPunk's Hoodie",
		image: dafthoodie,
		description:
			"The DaftPunk's hoodie which was shared by the musicians(DaftPunk) which was then bought from Him. Its here for a discounted fee.",
	},
	{
		name: 'DaftPunk V1',
		image: daftpunkHelmet1,
		description:
			"The first DaftPunk hoodie. This is of the right hand sided DaftPunk and was created by the original creators of the DaftPunk's",
	},
	{
		name: 'DaftPunk V2',
		image: daftpunkHelmet2,
		description:
			"The second DaftPunk hoodie. This is of the left hand sided DaftPunk and was created by the original creators of the DaftPunk's",
	},
	{
		name: "Lee Bryce's Giutar",
		image: guitar,
		description:
			'Lorem ipsum dolor sit amet, perferendis nihil qui delectus hic voluptatibus facere voluptas, iusto minima iste harum et id  nobis, vel voluptatem odio.',
	},
	{
		name: 'Live Concert',
		image: live,
		description:
			'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, esse illum perferendis nihil qui delectus hic  vel voluptatem odio.',
	},
	{
		name: "Nirvana's Original Stone",
		image: stone,
		description:
			' hic voluptatibus facere voluptas, iusto minima iste harum et id quisquam nobis, vel voluptatem odio.',
	},
];
